$(document).ready(function () 
{
	if (typeof(setMenu) == "function")
		setMenu('span.drag', 'playlist');
	
	setupPlaylist();

	//Felugró menüben lévő playlist bar opció
});

	var pid=0;
	var playnow = "";
	var is_playing = 1;
	var is_looping = false;
	var cnt = 0;
	var show = false;
	var loaded = false;
	var playlist;
	var resizeTimer = null;

	$(window).bind('resize', function() {
		if (resizeTimer) clearTimeout(resizeTimer);
		resizeTimer = setTimeout(resizePlaylist, 100);
	});	

	function resizePlaylist() {
		$("#playlist_inner #videos_strip").width($(window).width()-120);
	}

	function checkPlayerReady() {
		var fplayer = swfobject.getObjectById("player");
		if (!fplayer)
			setTimeout ( checkPlayerReady, 1000 );
		else {
			//alert('f:'+fplayer)
			//if (!fplayer.IV_isLoaded()) {
			//	setTimeout ( checkPlayerReady, 1000 );
			//} else {
			//	alert ('player ready')
			//	fplayer.IV_playist();
			//}
		}
	}

	function setPosition() {
		if (playlist) {
			for (var i=0,j=playlist.length; i<j-1; i++) {
				if (playlist[i].url_title == playnow &&  i * 140 < $(window).width() 	) {
					$('#playlist_inner #videobar').css("left", -i*140+"px");
				}
			}
		}
	}

	function playNextVideo() {
		var next_item = "";
		for (var i=0,j=playlist.length; i<j-1; i++) {
			if (playlist[i].url_title == playnow ) {
				next_item = playlist[i+1].url_title;
			}
		}
		if (next_item) {
			getVideoSite(next_item);
		} else {
			if (is_looping)
			{
				getVideoSite(playlist[0].url_title);
			}
		}
	}

	function playPrevVideo() {
		for (var i=0,j=playlist.length; i<j-1; i++) {
			if (playlist[i].url_title == playnow ) {
				getVideoSite(playlist[i-1].url_title);
			}
		}
	}

	function playVideo(id) {
		for (var i=0,j=playlist.length; i<j-1; i++) {
				if (playlist[i].url_title == id  ) {
					getVideoSite(playlist[i].url_title);
				}
		}
	}

	function getVideoSite(url_title) {
		if ( is_playing ) {
			var location=("/video/" +url_title +"/?pid="+pid+"#video");
			this.location.href = location;
		} else {
			//alert('playlist paused');
		}
	}

	function getPlayList() {
		url = "/playlist/get/"+pid;
		$.getJSON(url, function(data) {
			playlist = data;
			if (show && data) showPlaylists();
		} );
	}

	function getPlayListHTML() 
	{
		$('#context_profile a#showHideMyLists').html('Listáim elrejtése');

		if (loaded ) 
		{
			if (show) {
				$('#context_profile a#showHideMyLists').html('Listáim mutatása');
				hidePlaylists();
			} else {
				showPlaylists();
			}
		} 
		else 
		{
			url = "/playlist_bar?load=1";
			$("#plContainer").load(url, function() {
				loaded = true;
				setupPlaylist();
				showPlaylists();
			});
		}
	}

	function pauseplayPlaylist() {
		is_playing = !is_playing;
		player.IV_pauseplay();
		setPlayPause();
	}

	function setPlayPause() {
		if(is_playing) {
			$("#plplay").css("display", "none");
			$("#plpause").css("display", "inline");
		} else {
			$("#plplay").css("display", "inline");
			$("#plpause").css("display", "none");
		}
	}

	function loopPlaylist() 
	{
		is_looping = !is_looping;
		setLoop();
	}

	function setLoop() {
/*		if(is_looping) {
			$("#loopOn").css("display", "none");
			$("#loopOff").css("display", "inline");
			setCookie('playlist_loop', 1, 1, '/', document.domain );
		} else {
			$("#loopOn").css("display", "inline");
			$("#loopOff").css("display", "none");
			setCookie('playlist_hide', 0, 1, '/', document.domain );						
			deleteCookie('playlist_loop','/', document.domain ); 
		} */
	}

	function setupPlaylist() 
	{
		$('#playlist_inner #videos_strip').css("width", ( $(window).width() - 120 )+"px");

		//setMenu('span.drag', 'playlist');

		//Close arrow
		$('div#closePl').click(function (e) {
			$('div#closePl').css("display", "none");
			$('div#openPl').css("display", "block");
			$('div#playlist').css("bottom", "-100px");
/*			setCookie('playlist_hide', 1, 1, '/', document.domain ); */
		});
		
		//Open arrow
		$('div#openPl').click(function (e) {
			$('div#playlist').css("bottom", "0px");
			$('div#closePl').css("display", "block");
			$('div#openPl').css("display", "none");
/*			setCookie('playlist_hide', 0, 1, '/', document.domain );			*/
/*			deleteCookie('playlist_hide','/', document.domain ); */
		})

		//Del playlist
		$('div#controlls #removeList').click(function (e) {
			var url_title = $(this).find('input').val();
			//$(this).remove();
			videoBoxHandler.removePlaylist(pid);
		})		

		//Jobbra gordit
		$('div#rollright_btn').click(function (e) {
			var pos = parseInt($('#playlist_inner #videobar').css("left"));
			if (pos > -cnt*140 + ($(window).width() - 400) && parseInt($('#playlist_inner #videobar').css("opacity")) == 1 )
			{
				//$('#playlist_inner #videobar').css("left", pos-140+"px");
				$('#playlist_inner #videobar').css("opacity", 0.4);
				$('#playlist_inner #videobar').animate({
					left: '-=360',
				}, 1000, function() {
					$('#playlist_inner #videobar').css("opacity", 1);
				});
			}
		});

		//Balra gordit
		$('div#rollleft_btn').click(function (e) {
			var pos = parseInt($('#playlist_inner #videobar').css("left"));
			if (pos < -10  && parseInt($('#playlist_inner #videobar').css("opacity")) == 1 )
			{
				//$('#playlist_inner #videobar').css("left", pos+140+"px");
				$('#playlist_inner #videobar').css("opacity", 0.4);
				$('#playlist_inner #videobar').animate({
					left: '+=360',
				}, 1000, function() {
					$('#playlist_inner #videobar').css("opacity", 1);
				});
			}
		});

		$('#playlist_inner #videobar li').mouseover(function (e) {
			$('div#playlist .videotitle').html(" "+$(this).find('span').html());
		});
		$('#playlist_inner #videobar li').mouseout(function (e) {
			$('div#playlist .videotitle').html('');
		});

		cnt = $('#playlist_inner #videobar li').size();
		pid = $('#playlist_inner #videos_strip span#pid').html();
		setPlayPause();
		getPlayList(pid);
		if (GetCookie('playlist_hide') == 1 ) {
			$('div#playlist').css("bottom", "-100px");
			$('div#openPl').css("display", "block");
			$('div#closePl').css("display", "none");
		} else {
			$('div#playlist').css("bottom", "0px");
			$('div#openPl').css("display", "none");
			$('div#closePl').css("display", "block");
		}
		if (GetCookie('playlist_loop') == 1 ) {
			loopPlaylist();
		}
		$('ul#videobar span.removeFav').click(function (e) {
			var url_title = $(this).find('input').val();
			//$(this).remove();
			videoBoxHandler.removeFromFavourite(url_title, $(this));
		})
		$('ul#videobar span.remove').click(function (e) {
			var url_title = $(this).find('input').val();
			videoBoxHandler.removeFromPlaylist(pid, url_title, $(this));
		});

		show = false;
	}

	function showPlaylists() 
	{
		$('#plContainer').show();
		return;
		
		$('div#playlist').css("height", "130px");
		$('div#playlist').css("width", "100%");
		$('div#playlist').fadeIn();
		$('div#playlist_inner').fadeIn();
		setPosition();
		show=true;
	}

	function hidePlaylists() {
		$('div#playlist').fadeOut();
		$('div#playlist').css("height", "1px");
		show=false;
	}

	var playlistOrder = [];
	var lastVideoPosition = null;
	function stopPlaylistSort(event, ui) 
	{
		storePlaylistOrder();
		var urlTitle = $(ui.item[0]).attr('rel');
		var newVideoPosition = playlistOrder.indexOf(urlTitle);

		if (newVideoPosition == lastVideoPosition)
			return true;
		$("#videobar").sortable('disable');
		$.ajax({
			url: '/playlistadmin', 
			data: {
				action: 'videoHandler',
				op: 'playlistMoveVideo',
				pid: $("#videobarPid").val(),
				url_title: urlTitle,
				oldPlace: lastVideoPosition,
				newPlace: newVideoPosition
			},
			success: function() {
				$("#videobar").sortable("enable");
			}
		});
	}

	function startPlaylistSort(event, ui) {
		lastVideoPosition = playlistOrder.indexOf($(ui.item[0]).attr('rel'));
	}
	function storePlaylistOrder() {
		playlistOrder = [];
		$("#videobar li").each(function(){
			playlistOrder.push($(this).attr('rel'));
		})
	}

	var lastCmThumb = "init";


function hideContextMenus(){
	$('.context_menu:visible:not(:animated)').fadeOut(250);
}

var videoBoxHandler = {
	setFavourite: function (addOrRemove) {
		$.post ('/playlistadmin', {
			action: 'videoHandler',
			op: 'setFavourite',
			hash: $("#emb_hash").val(),
			url_title : $("#context_thumbnail .what").html(),
			addOrRemove: 1
			}, function () {
				$("#context_thumbnail").fadeOut ();
				myAlert ('A videót hozzáadtuk!', 'Kedvencekhez adás');
				loaded = false;
				getPlayListHTML();
			}, 'json');
	},
	addToPlaylist: function (pid, urlTitle) 
	{
		$.post ('/playlistadmin', 
		{
			action: 'videoHandler',
			op: 'addToPlaylist',
			hash: $("#emb_hash").val(),
			url_title : !urlTitle ? $("#context_thumbnail .what").html() : urlTitle,
			pid: pid,
			addOrRemove: 1
		}, 
		function (data) 
		{
			$("#context_thumbnail").fadeOut ();
			loaded = false;
	
			getPlayListHTML();
	
			myAlert ('A videót hozzáadtuk!', 'Listához adás');
		}, 'json');
	},
	removeFromPlaylist: function (pid, url_title, item) {
		item.parent().fadeOut (250, function() { $(this).remove (); });
		$.post ('/playlistadmin', {
			action: 'videoHandler',
			op: 'addToPlaylist',
			hash : '',
			url_title : url_title,
			pid: pid,
			addOrRemove: 0
			}, function (data) {
				$("#context_thumbnail").fadeOut ();
				myAlert ('A videót töröltük a listáról!', 'Törlés a listáról');
			}, 'json');
	},
	removeFromFavourite: function (url_title, item) {
		item.parent().fadeOut (250, function() { $(this).remove (); });
		$.post ('/playlistadmin', {
			action: 'videoHandler',
			op: 'setFavourite',
			hash : '',
			url_title : url_title,
			addOrRemove: 0
			}, function (data) {
				$("#context_thumbnail").fadeOut ();
				myAlert ('A videót töröltük a kedvencekből!', 'Törlés a kedvencekből');
			}, 'json');
	},
	removePlaylist: function (pid) {
		$.post ('/playlistadmin', {
			action: 'videoHandler',
			op: 'removePlaylist',
			pid: pid
			}, function (data) {
				window.location.href=window.location.href.split('?pid=')[0];
			}, 'json');
	},
	createPlaylist: function (title, url_title) 
	{
		if ($("#context_thumbnail table tbody tr").size() >= 28) // 25, csak van 3 static tr is a table-ben
		{
			$("#context_thumbnail").fadeOut();
			myAlert ('Már túl sok listát hoztál létre!', 'Új lista');
			return false;
		}

		$.post ('/playlistadmin', 
		{
			action: 'videoHandler',
			op: 'createPlaylist',
			//video beloldal
			hash: $("#emb_hash").val(),
			//fooldal
			url_title: url_title,
			title: title
		}, function (data) 
		{
			if (typeof data.success === 'undefined');
			else if (typeof data.playlist === 'undefined');
			else if (data.success != '1');
				//alert ('nem1');
			else {
				var html = '<tr class="menu_item"><td class="cm_l"></td><td class="cm_bg"><div class="content">'
					+ '<a href="#" onclick="videoBoxHandler.addToPlaylist(' + data.playlist.id + ',1);showPlaylists(); return false;">' + data.playlist.title + '</a> '
					+ '</div></td><td class="cm_r"></td></tr>';
				$("#context_thumbnail table tbody tr").last().before(html);

				//$("#context_thumbnail").fadeOut();
				hideAddPlaylistForm ();
				myAlert ('A listát létrehoztuk, a videót hozzáadtuk!', 'Új lista');
				getPlayListHTML();
				};
		}, 'json');
		return false;
	},
	addRate: function () 
	{
		$.post ('/playlistadmin', {
			action: 'videoHandler',
			op: 'rateVideo',
			hash: $("#emb_hash").val()
			//,url_title: $("#context_thumbnail .what").html()
			}, function (data) {
				if (typeof data.success != 'undefined') {
					if (data.success == '1')
						myAlert ('A szavazatot rögzítettük!','Szavazás videóra');
					else
						myAlert ('Már szavaztál!', 'Szavazás videóra');
					}
			}, 'json');
	}
}
